import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {

  private readonly supportedLanguages = ['pt-br', 'es-es', 'en-us'];

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    
    const langParam = route.queryParams['lang'];
    if (langParam && this.supportedLanguages.includes(langParam.toLowerCase())) {
      sessionStorage.setItem('language', langParam.toLowerCase());
    }
    return true;
  }
}